import Modules from '@app/modules';
import Icons from '@app/global/icons';
import Store from '@app/modules/RF/Search/store';
import SearchComponent from '@app/modules/RF/Search/Search.vue';
import FrontNavComponent from '@app/modules/RF/Search/FrontNav.vue';
import IconBarComponent from '@app/modules/RF/Search/IconBar.vue';
import { faSearch, faPollH, faNewspaper, faCalendarAlt, faAlignLeft, faEllipsisH } from '@fortawesome/pro-light-svg-icons';
import { faSearch as faSearchSolid } from '@fortawesome/free-solid-svg-icons';
Modules.register({
    namespace: 'RF/Search',
    store: Store,
    taggedComponents: {
        app: [SearchComponent],
        nav: [FrontNavComponent],
        iconBar: [IconBarComponent]
    }
});
Icons.add(faSearch, faPollH, faNewspaper, faCalendarAlt, faAlignLeft, faEllipsisH, 
// @ts-ignore
faSearchSolid);
